import { defineComponent } from 'vue';
import NavigationBarCode from '@/presentation/components/shared/navigation-bar/navigation-bar.code';

export default defineComponent({
	setup: () => {
		const code = new NavigationBarCode();

		return {
			internalNavItems: code.internalNavItems,
			externalNavItems: code.externalNavItems,
			isPathActive: code.isPathActive.bind(code),
			navigateToPage: code.navigateToPage.bind(code),
			doesPageRequireAction: code.doesPageRequireAction.bind(code)
		};
	}
});
